import React from 'react';
import TextEditor from '../../Editor/EditorReadOnly';
import { createStyles, Grid, makeStyles } from '@material-ui/core';
import { bucketURL, showEditIconForBg, showEditIconWhite } from '../../../server/constants';

interface Props {
  bgImage?: string;
  title: string;
  subTitle: string;
}

export const bannerStyles = makeStyles((theme) =>
  createStyles({
    heroContent: {
      padding: '0% 15px 2% 15px',
      position: 'relative',
      backgroundSize: 'cover',
      backgroundPosition: 'center center',
      backgroundRepeat: 'no-repeat',
      minHeight: 350,
      marginTop: 150,
      display:'flex',
      alignItems:'center',
      [ theme.breakpoints.down('md') ]: {
        marginTop: 110,
      },
      [ theme.breakpoints.down(767) ]: {
        minHeight: 300,
      },
    },
    textWhite: {
      color: '#FFFFFF',
    },
    register: {
      background: '#01305F',
      height: '100%',
      position:'relative',
      minHeight: '406px'
    },
    registerContent:{
      background: '#01305F',
      right: 0,
      verticalAlign: "middle",
      display: "flow",
      position: "absolute",
      left: "0",
      top: "33%",
      color: "#FFFFFF",
      textAlign: "center"
    },

    loginSpace: {
      padding: '1rem 0px 1rem 0px'
    }
  }),
);

const Banner: React.FC<Props> = ({bgImage = 'img-hero-agent-lookup.jpg', title, subTitle}) => {
  const classes = bannerStyles();
  const heroProps: any = {
    className: classes.heroContent,
    style: {backgroundImage: `url("${bucketURL}/${bgImage}")`}
  };
  const bgImageTEProps = {
    bgImage: true,
    sectionId: 'bgImage',
    src: `${bucketURL}/${bgImage}`,
    upperDivClass: showEditIconForBg,
  };
  const titleTEProps = {
    className: 'textWhite',
    content: title,
    sectionId: 'title',
    upperDivClass: showEditIconWhite
  };
  const subTitleTEProps = {
    className: 'textWhite',
    content: subTitle,
    sectionId: 'subTitle',
    upperDivClass: showEditIconWhite
  };

  return (
    <span className="showEditIconForBg">
        <TextEditor {...bgImageTEProps} />
        <div {...heroProps}>
            <Grid container justifyContent="center">
                <Grid item xs={12} md={12} lg={12} xl={8} style={{textAlign: 'center'}}>
                    <Grid container spacing={3} justifyContent="center" alignItems="center">
                        <Grid item xs={12} md={6} lg={12}>
                            <TextEditor {...titleTEProps} />
                            <TextEditor {...subTitleTEProps} />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </div>
    </span>
  );
};

export default Banner;
